import { useCallback } from 'react';

import { useReactFlow } from '@xyflow/react';

/** Centers on a node by id; no animation, since Flow's onMove boundary clamp cancels an animated setCenter mid-flight. */
export const useCenterOnNode = (): ((nodeId: string) => void) => {
  const reactFlowInstance = useReactFlow();

  return useCallback(
    (nodeId: string) => {
      const internalNode = reactFlowInstance.getInternalNode(nodeId);
      if (internalNode === undefined) return;

      const { x, y } = internalNode.internals.positionAbsolute;
      const width = internalNode.measured.width ?? 0;
      const height = internalNode.measured.height ?? 0;
      const zoom = 1.2;

      void reactFlowInstance.setCenter(x + width / 2, y + height / 2, { zoom });
    },
    [reactFlowInstance]
  );
};

export default useCenterOnNode;
